import { useState } from 'react';
import { DialogFooter, DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog';
import { Button } from '../../../../common/components/ui/button';
import { refreshShoppingCart } from '../../actions/cartActions';
import { useTranslation } from 'react-i18next';
import { CartDialogConfirmCancel } from '../shared/CartDialogConfirmCancel';

function handleShoppingCartRefresh() {
  refreshShoppingCart();
}

export function CartDialogCartReservationExpired() {
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (showConfirmation) {
    return <CartDialogConfirmCancel onBack={() => setShowConfirmation(false)} />;
  }

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center'}>{t('Die Reservation Ihrer Artikel ist verfallen')}</DialogTitle>
      </DialogHeader>
      <div>
        <p>{t('Artikel im Warenkorb sind jeweils für 2 Stunden für Sie reserviert.')}</p>
        <p>{t('Diese Reservation ist nun verfallen.')}</p>
        <p>{t('Sie können eine neue Reservation vornehmen oder den Warenkorb verwerfen.')}</p>
      </div>
      <DialogFooter className={'flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <Button
          variant={'primaryOutline'}
          onClick={() => setShowConfirmation(true)}
          data-testid={'cart-expired-discard-button'}
        >
          {t('Warenkorb verwerfen')}!
        </Button>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus -- intentional: focus primary action in modal dialog per WAI-ARIA */}
        <Button onClick={handleShoppingCartRefresh} data-testid={'cart-expired-keep-button'} autoFocus={true}>
          {t('Erneut reservieren')}!
        </Button>
      </DialogFooter>
    </>
  );
}
